import { render, staticRenderFns } from "./BreadcrumbList.vue?vue&type=template&id=24cd9284"
import script from "./BreadcrumbList.js?vue&type=script&lang=js&external"
export * from "./BreadcrumbList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports